export default [
  {
    path: '/userCenter', // 身份管理中心
    name: 'userCenter',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/index.vue'
      )
    }
  },
  {
    path: '/address', // 身份管理中心-地址填写
    name: 'address',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/Address.vue'
      )
    }
  },
  {
    path: '/userInfo', // 身份管理中心-个人信息
    name: 'userInfo',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/UserInfo.vue'
      )
    }
  },
  {
    path: '/addcard', // 保险号绑卡
    name: 'addCard',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/addBXCard.vue'
      )
    }
  },
  {
    path: '/verify', // 身份确认、目前UI已重新修改
    name: 'verify',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/verify.vue'
      )
    }
  },
  {
    path: '/zjd/contactUs', // 联系我们
    name: 'contactUs',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/contactUs.vue'
      )
    }
  },
  {
    path: '/zjd/commonQuestion', // 常见问题
    name: 'commonQuestion',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/commonQuestion.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/questionDetail', // 常见问题详情
    name: 'questionDetail',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/questionDetail.vue'
      )
    }
  },
  {
    path: '/realtime', // 实时动态
    name: 'realtime',
    component: () => {
      return import(
        /* webpackChunkName: "usercenter" */ '@/views/usercenter/nowDynamic.vue'
      )
    }
  }
]
